import { TabPanel, Text } from '@chakra-ui/react'
import React from 'react'
import { PopupItemCall } from '~/pages/Popup/PopupItemCall'
import { textStyleKeys } from '~/themes/textStyles'

import {
  PopupQueueItem,
  PopupQueueItemType,
  PopupQueueItemTypes,
} from '@mangovoice/types'

import { PopupItemText } from './PopupItemText'

const processQueueType = (args: {
  items: PopupQueueItem[]
  type: PopupQueueItemType
  shouldRing: boolean
}) => {
  const { items, type, shouldRing } = args

  if (items.length === 0) {
    return (
      <Text paddingTop={2} textStyle={textStyleKeys.Body3}>
        No {type === PopupQueueItemTypes.MESSAGE ? 'messages' : 'calls'}
      </Text>
    )
  }

  // TODO: Maybe handle more than one at a time in the future.
  //  For now we'll take the newest (last) in the queue for type
  // return items.map((item) => {
  return (
    <>
      {type === PopupQueueItemTypes.MESSAGE && (
        <>
          <PopupItemText
            key={items[0]._id}
            queueItem={items[items.length - 1]}
            totalMessages={items.length}
          ></PopupItemText>
        </>
      )}
      {type === PopupQueueItemTypes.CALL && (
        <>
          <PopupItemCall
            key={items[0]._id}
            queueItem={items[items.length - 1]}
            autoPlay={shouldRing}
          ></PopupItemCall>
        </>
      )}
    </>
  )
  // })
}

export const PopupItem = (props: {
  queueItems: PopupQueueItem[]
  type: PopupQueueItemType
  shouldRing?: boolean
}) => {
  const { queueItems, type, shouldRing } = props

  return (
    <>
      <TabPanel
        display={'flex'}
        flexDirection="column"
        flex="1"
        flexGrow={1}
        padding={2}
        justifyContent={'space-between'}
        height={'100%'}
      >
        <>
          {processQueueType({
            items: queueItems,
            type,
            shouldRing: shouldRing || false,
          })}
        </>
      </TabPanel>
    </>
  )
}
